import dayjs from 'dayjs';

const isTruthyFlag = value =>
  value === true || value === 1 || value === '1' || value === 'true';

export const resolveImprovementClosingDate = (rows = []) => {
  for (const row of rows) {
    const detail = row?.detailRow ?? row;
    const isOfferImp = isTruthyFlag(
      detail?.isImprovement ?? detail?.IsImprovement
    );
    const isCounterImp = isTruthyFlag(
      detail?.counterIsImprovement ?? detail?.CounterIsImprovement
    );
    if (!isOfferImp && !isCounterImp) continue;

    const date =
      (isCounterImp
        ? (detail?.counterClosingDateImprovement ??
          detail?.CounterClosingDateImprovement)
        : null) ??
      detail?.closingDateImprovement ??
      detail?.ClosingDateImprovement ??
      detail?.dateImprovement ??
      detail?.DateImprovement ??
      null;

    if (date) return date;
  }
  return null;
};

export const isImprovementClosingActive = date => {
  if (!date) return false;
  return !dayjs().isAfter(dayjs(date));
};

export const formatImprovementClosingDate = date =>
  dayjs(date).format('DD MMM YYYY HH:mm');

export const resolveAlphaImprovementSource = (detailRow, kind = 'offer') => {
  if (kind === 'counter') {
    return (
      detailRow?.counterAlphaImprovement ??
      detailRow?.CounterAlphaImprovement ??
      null
    );
  }
  return detailRow?.alphaImprovement ?? detailRow?.AlphaImprovement ?? null;
};

const pickFirstNonEmpty = (obj, keys = []) => {
  if (!obj || typeof obj !== 'object') return undefined;
  for (const key of keys) {
    const value = obj[key];
    if (value === null || value === undefined) continue;
    const text = String(value).trim();
    if (text !== '') return text;
  }
  return undefined;
};

export const getAlphaImprovementFieldValue = (
  detailRow,
  kind = 'offer',
  field = 'alpha',
  { fallbackToBase = true } = {}
) => {
  const source = resolveAlphaImprovementSource(detailRow, kind);

  const nestedKeys =
    field === 'dyed'
      ? ['dyed', 'Dyed', 'alphaDyed', 'AlphaDyed']
      : field === 'undyed'
        ? ['undyed', 'Undyed', 'alphaUndyed', 'AlphaUndyed']
        : ['alpha', 'Alpha'];

  const flatKeys =
    kind === 'counter'
      ? field === 'dyed'
        ? [
            'improvementDyed2',
            'ImprovementDyed2',
            'improvementDyed',
            'ImprovementDyed',
          ]
        : field === 'undyed'
          ? [
              'improvementUndyed2',
              'ImprovementUndyed2',
              'improvementUndyed',
              'ImprovementUndyed',
            ]
          : [
              'improvementAlpha2',
              'ImprovementAlpha2',
              'improvementAlpha',
              'ImprovementAlpha',
              'cargoRatioAlphaImprovement',
            ]
      : field === 'dyed'
        ? ['improvementDyed', 'ImprovementDyed']
        : field === 'undyed'
          ? ['improvementUndyed', 'ImprovementUndyed']
          : [
              'improvementAlpha',
              'ImprovementAlpha',
              'cargoRatioAlphaImprovement',
            ];

  const baseKeys =
    kind === 'counter'
      ? field === 'dyed'
        ? ['counterDyed', 'CounterDyed', 'dyed2', 'Dyed2']
        : field === 'undyed'
          ? ['counterUndyed', 'CounterUndyed', 'undyed2', 'Undyed2']
          : ['counterAlpha', 'CounterAlpha']
      : field === 'dyed'
        ? ['dyed', 'Dyed', 'unitBbl']
        : field === 'undyed'
          ? ['undyed', 'Undyed', 'cbm']
          : [
              'alpha',
              'Alpha',
              'alphaMitra1',
              'AlphaMitra1',
              'alpha1',
              'Alpha1',
            ];

  return (
    pickFirstNonEmpty(detailRow, flatKeys) ??
    pickFirstNonEmpty(source, nestedKeys) ??
    (fallbackToBase ? pickFirstNonEmpty(detailRow, baseKeys) : undefined) ??
    ''
  );
};

const formatAlphaPrice = (value, unitSuffix = 'USD/BBL') => {
  if (value === null || value === undefined || value === '') return '-';
  const text = String(value).trim();
  if (/USD|BBL|MT/i.test(text)) return text;
  return `${text} ${unitSuffix}`;
};

export const formatAlphaImprovementDisplay = (
  detailRow,
  kind = 'offer',
  field = 'alpha',
  unitSuffix = 'USD/BBL'
) => {
  const text = String(
    getAlphaImprovementFieldValue(detailRow, kind, field) ?? ''
  ).trim();
  if (!text) return '-';
  return formatAlphaPrice(text, unitSuffix);
};
